<template>

  <div id="wangEditor">
     <div ref="editor" style="text-align: left"></div>
  </div>
 
</template>

<script>
import E from "wangeditor";

export default {
  name: "wangEditor",
  props: {
    initText: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editor: null,
      firstStatus: 0,
    };
  },
  destory() {},
  mounted() {
    this.firstStatus = 1;
    var _this = this;
    _this.editor = new E(this.$refs.editor);

    // Disable auto focus
    _this.editor.config.focus = false;

    //配置颜色
    _this.editor.config.colors = [
      "#000000",
      "#eeece0",
      "#1c487f",
      "#4d80bf",
      "#c24f4a",
      "#8baa4a",
      "#7b5ba1",
      "#46acc8",
      "#f9963b",
      "#ffffff",
      "#00cc99",
    ];

    // 默认情况下，显示所有菜单
    _this.editor.config.menus = [
      "head",
      "bold",
      "fontSize",
      "fontName",
      "italic",
      "underline",
      "strikeThrough",
      "indent",
      "lineHeight",
      "foreColor",
      "backColor",
      "link",
      "list",
      "justify",
      "quote",
      "emoticon",
      "image",
      "video",
      "table",
      "splitLine",
      "undo",
      "redo",
    ];

    // 层级 - Lowered z-index to prevent focus issues
    _this.editor.config.zIndex = 100;

    /* 处理上传图片的controller路径 */
    _this.editor.config.uploadImgServer = _this.$api.api.uploadImg;
    _this.editor.config.uploadImgMaxSize = 100 * 1024 * 1024;
    _this.editor.config.uploadImgMaxLength = 100;
    _this.editor.config.uploadFileName = "file";
    _this.editor.config.uploadImgParams = {
      mubanId: _this.$api.mubanId,
      token: _this.$store.state.TOKEN,
      no:new Date(new Date()).valueOf() + "_" + Math.round(Math.random() * 1000)
    };

    _this.editor.config.uploadImgHooks = {
      customInsert: function (insertImg, result, editor) {
        var url = result.data.path;
        insertImg(url);
      },
    };

    // 视频配置
    _this.editor.config.uploadVideoServer = _this.$api.api.uploadVideo;
    _this.editor.config.uploadVideoName = "file";
    _this.editor.config.uploadVideoParams = {
      mubanId: _this.$api.mubanId,
      token: _this.$store.state.TOKEN,
      no:new Date(new Date()).valueOf() + "_" + Math.round(Math.random() * 1000)
    }

    _this.editor.config.uploadVideoHooks = {
      customInsert: function(insertVideoFn, result) {
        if(result.code == 200){
          let urls = _this.$api.urls + result.data.data.path;
          insertVideoFn(urls)
        }
      }
    }

    _this.editor.config.onchange = (html) => {
      var text = _this.editor.txt.text();
      _this.$emit("myEditorContent", html);
    };

    _this.editor.config.onfocus = (html) => {
      _this.firstStatus = 0;
    };

    // Modified blur handler to prevent content overwrite
    _this.editor.config.onblur = (html) => {
      if (_this.editor.txt.html() !== _this.initText) {
        _this.$emit("myEditorContent", _this.editor.txt.html());
      }
    };

    // Initialize content
    _this.editor.create();
    _this.editor.txt.html(_this.initText || '');
  },
  watch: {
    initText(newVal) {
      if (this.editor && newVal !== this.editor.txt.html()) {
        this.editor.txt.html(newVal);
      }
    },
  },
};
</script>

<style scoped>
#wangEditor{
  overflow:hidden;
  position: relative;
  z-index: 100;
}

</style>



// WEBPACK FOOTER //
// src/components/wangEditor.vue